import React, { FC, PropsWithChildren } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Icon } from "../../../components/";
import SearchBtnTooltip from "./SearchBtnTooltip";
import { SEARCH_MODALS_NAMES } from "../../search/hooks/useSearchModals";

type Props = {
  showTooltip: boolean;
  isLoading: boolean;
  onClick: ({ type }: { type: string }) => void;
};

const GlobalSearchButton: FC<PropsWithChildren<Props>> = ({
  showTooltip,
  isLoading,
  onClick
}) => (
  <SearchBtnTooltip
    condition={showTooltip}
    tooltip={children => (
      <OverlayTrigger
        overlay={
          <Tooltip id="header-warning-tooltip">
            {isLoading ? "Searching..." : "Please select search criteria."}
          </Tooltip>
        }
        placement="bottom"
      >
        {children}
      </OverlayTrigger>
    )}
  >
    <div className="search__button-submit-btn-container">
      <Button
        id="global-search-btn-search"
        data-testid="global_search_btn_search"
        variant="link"
        className={`search__button search__button--submit`}
        disabled={isLoading}
        onClick={() => onClick({ type: SEARCH_MODALS_NAMES.SEARCH })}
      >
        <Icon name="search" />
      </Button>
    </div>
  </SearchBtnTooltip>
);

export default GlobalSearchButton;
